import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
import Error from '../views/404.vue'
import Results from '../views/results.vue'
import donation from '../views/selfPay/donation'
import selfEdu from '../views/selfEdu/query'
import register from '../views/selfEdu/register'
import history from '../views/selfEdu/historyList'
import Login from '../views/loginPage/login'
import LoginIndex from '../views/loginPage/index'
import LoginSearch from '../views/loginPage/search'
import PayList from '../views/loginPage/payList'
import User from '../views/loginPage/user'
import Add from '../views/loginPage/add'
import selfOtherPay from '../views/selfPay/otherPay'
import bdcResults from '../views/bdcPay/results'
import bdcIndex from '../views/bdcPay/index'
import batchList from '../views/bdcPay/batchList'
import jgPay from '../views/jgPage/pay'
import jgPayweb from '../views/jgPage/payWeb'
import ipcPay from '../views/ipcPay/index'
import ipcPayResults from '../views/ipcPay/results'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/404',
    name: '404',
    component: Error
  },
  {
    path: '/pages/results/results',
    name: 'results',
    component: Results
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/loginIndex',
    name: 'LoginIndex',
    component: LoginIndex,
    children: [
      {
        path: '/',
        component: LoginSearch
      },
      {
        path: 'add',
        component: Add
      },
      {
        path: 'user',
        component: User
      },
    ]
  }, {
    path: '/payList',
    name: 'payList',
    component: PayList
  },
  {
    path: '/donation',
    name: 'donation',
    component: donation
  },
  {
    path: '/selfEdu',
    name: 'selfEdu',
    component: selfEdu
  },
  {
    path: '/pages/prepaid/register',
    name: 'register',
    component: register
  },
  {
    path: '/pages/prepaid/history',
    name: 'history',
    component: history
  },
  {
    path: '/otherPay',
    name: 'otherPay',
    component: selfOtherPay
  },
  {
    path: '/pages/bdcPay/results',
    name: 'bdcResults',
    component: bdcResults
  },
  {
    path: '/bdcPay/index',
    name: 'bdcIndex',
    component: bdcIndex
  },
  {
    path: '/bdcPay/batchList',
    name: 'batchList',
    component: batchList
  },
  {
    path: '/jgPay',
    name: 'jgPay',
    component: jgPay
  },
  {
    path: '/jgPayweb',
    name: 'jgPayweb',
    component: jgPayweb
  },
  {
    path: '/ipcPay',
    name: 'ipcPay',
    component: ipcPay
  },
  {
    path: '/ipcPay/ipcPayResults',
    name: 'ipcPayResults',
    component: ipcPayResults
  },
  { //不动产数据看板
    path: '/bdcDataStatistics',
    component: () => import('@/views/bdcPay/dataStatistics')
  },
  {
    path: '/eTicket',//查看电子票
    component: () => import('@/components/eTicket'),
  },
  {
    path: '/refundModify',//退费修改入口
    component: () => import('@/views/refundPay/login.vue'),
  },
  {
    path: '/refundModify/result',//退费修改结果页
    component: () => import('@/views/refundPay/results.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  //base: process.env.BASE_URL, 从git历史版本查看原来的配置
  base: 'h5',
  routes
})
export default router
